import React from 'react';
import PropTypes from 'prop-types'

const ParameterSummary = (props) => {
  const { showSummary, parameters } = props
  if (!showSummary) return null;

  return (
    <div className="summary">
      <div className="parameters-summary">
        <table className="table table-bordered parameters-summary-table">
          <tbody>
            <tr>
              <td><strong># of Layers</strong></td>
              <td>{parameters.number_of_layers}</td>
              <td><strong>Board Width</strong></td>
              <td>{parameters.board_width}</td>
            </tr>
            <tr>
              <td><strong>Thickness</strong></td>
              <td>{parameters.material_thickness}</td>
              <td><strong>Finish</strong></td>
              <td>{parameters.finish_plating}</td>
            </tr>
            <tr>
              <td><strong>Material</strong></td>
              <td>{parameters.material_type}</td>
              <td><strong>Copper Widht Inner</strong></td>
              <td>{parameters.copper_inners}</td>
            </tr>
            <tr>
              <td><strong>Board Lenght</strong></td>
              <td>{parameters.board_length}</td>
              <td><strong>Copper Weight Outer</strong></td>
              <td>{parameters.copper_outers}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

ParameterSummary.propTypes = {
  showSummary: PropTypes.bool.isRequired,
}

export default ParameterSummary
